import { styled } from "@mui/material";

export const Container = styled("section")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const Image = styled("img")(() => ({
  width: 200,
  margin: "24px 0 32px 0",
}));

export const Text = styled("span")(() => ({
  color: "#465869",
  font: "600 16px/18px Manrope",
}));
